/**
 * The client side of the password rules. The server is the authority; this only
 * saves a round trip for the two mistakes a person can see for themselves.
 *
 * One definition because two screens ask for a new password (reset, and
 * /activate, which covers both activation and the first-login gate) and a rule
 * that lives in each of them drifts: change the floor in one and a salon is told "8" here and "10" there.
 */

/** Matches the server's floor (`MIN_PASSWORD_LENGTH`). */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * The message to show for a new password that should not be submitted, or
 * `null` when it can be.
 *
 * Pass `confirmation` only where the form has a confirm field: leaving it out
 * skips the match check rather than comparing against `undefined`.
 */
export function validateNewPassword(
  password: string,
  confirmation?: string
): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (confirmation !== undefined && password !== confirmation) {
    return "Those passwords don't match.";
  }
  return null;
}
